import {captureException, getCurrentScope} from '@sentry/svelte';
import {getCookie} from 'general/libs/getCookie';

export const getVisitorId = () => getCookie('visitorId');

/**
 * Send error to Sentry
 * @param {Error} error - Error object
 * @param {string | {string: any}} [extras=''] - Additional details
 */
export function logWithSentry(error: Error, extras = {}) {
    const scope = getCurrentScope();
    scope.setUser({'x-visitor-id': getVisitorId()});
    scope.setContext('additionalDetails', {details: extras});
    scope.setLevel('error');
    captureException(error);
}
